export default __webpack_public_path__ + "e9ddf10f7d0696c7d206459932572014.png";